module.exports = __webpack_public_path__ + "img/16_79.0ada2d5e.png";